module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/tools/roulette-28db2b697e3ee4d5a666e641b5b4ee05.svg";